module.exports = __webpack_public_path__ + "assets/img_our-harvest.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_our-harvest.jpg
 ** module id = 128
 ** module chunks = 1
 **/